import { render, staticRenderFns } from "./transfers.vue?vue&type=template&id=81aa6a28&scoped=true"
import script from "./transfers.vue?vue&type=script&lang=js"
export * from "./transfers.vue?vue&type=script&lang=js"
import style0 from "./transfers.vue?vue&type=style&index=0&id=81aa6a28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81aa6a28",
  null
  
)

export default component.exports